import React, { Component } from 'react';
import { string, arrayOf, object } from 'prop-types';

import Masonry from 'masonry-layout';
import ArticleCard from '../ArticleCard/ArticleCard';
import FilterableTabs from 'elements/Tabs/FilterableTabs/FilterableTabs';

import styles from './TypeB.css';

class TypeB extends Component {
  static propTypes = {
    articles: arrayOf(object),
    primaryKey: string,
    secondaryKey: string,
    primaryLabel: string,
    secondaryLabel: string
  }

  state = {
    tabsSize: 'm'
  }

  cardMap = {
    1: 'highCard',
    2: 'lowCard',
    3: 'lowCard',
    4: 'highCard',
    5: 'lowCard',
    6: 'highCard',
    7: 'highCard',
    8: 'lowCard',
  };

  componentDidMount = () => {
    this.updateDimensions();

    this.msnry = new Masonry(`.${styles.grid}`, {
      itemSelector: `.${styles.gridItem}`,
      columnWidth: `.${styles.gridSizer}`,
      percentPosition: true,
      horizontalOrder: true
    });

    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate = () => this.msnry.reloadItems();

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    if(window.innerWidth < 1024 && this.state.tabsSize !== 's') {
      this.setState({ tabsSize: 's' });
    } else if(window.innerWidth > 1024 && this.state.tabsSize !== 'm') {
      this.setState({ tabsSize: 'm' });
    }
  }

  render () {
    const { tabsSize } = this.state;
    const { articles, ...rest } = this.props;

    return (
      <section className={styles.section}>
        <FilterableTabs className={styles.filterable} items={articles} {...rest} size={tabsSize}>
          {(results) => {
            let cardCounter = 1;

            return (
              <div className={styles.grid}>
                <div className={styles.gridSizer} />
                {results.map((item, i) => {
                  if (cardCounter > 8) { cardCounter = 1; }
                  const cardClass = this.cardMap[cardCounter];
                  cardCounter++;
                  
                  return (
                    <div className={styles.gridItem} key={`article-${i}`}>
                      <ArticleCard imgClass={styles[cardClass]} {...item} />
                    </div>
                  );
                })}
              </div>
            );
          }}
        </FilterableTabs>
      </section>
    );
  }
}

export default TypeB;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/ArticlesBanner/TypeB/TypeB.js